/**
 * <s-sticky-buy target="<id>"> — bottom purchase bar.
 *
 * Shows itself once the element named by `target` (the main add-to-cart area)
 * has scrolled above the viewport, and hides again when it comes back into
 * view. While hidden the bar is `inert` so its controls leave the tab order.
 */
class SStickyBuy extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.getElementById(this.getAttribute('target') || '');
    if (!target) return;

    this.#setVisible(false);
    this.#observer = new IntersectionObserver(([entry]) => {
      // Only show when the target is above the viewport, not when it's still below it.
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
    this.setAttribute('aria-hidden', String(!visible));
  }
}

if (!customElements.get('s-sticky-buy')) {
  customElements.define('s-sticky-buy', SStickyBuy);
}
